import restClient from "../restClient";

export const getInventoryId = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.get(`inventories/${id}`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
export const getInventories = async (search, status, location, altLocation, page, pageSize, options = {}, tableFilters = {}) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      signal: options.signal,

    };
    const response = await restClient.get(`inventories`, { ...config, params: { search, status, location, altLocation, page, pageSize, tableFilters } });
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getSAInventories = async (search, status, location, altLocation, page, pageSize, options = {}, tableFilters = {}, tenant) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      signal: options.signal,
    };
    const response = await restClient.get(`sa/inventories`, { ...config, params: { search, status, location, altLocation, page, pageSize, tableFilters, tenant } });
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const deleteInventory = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.delete(`inventories/${id}`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    return null;
  }
};

export const createInventory = async (data) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await restClient.post(`inventories`, { data: data }, config);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const getInventoryDetail = async (id, tab) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.get(`inventory-detail/${id}/${tab.toLowerCase().replace(/\s+/g, '-')}`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getInventoryWebDetail = async (id) => {
  const tabs = ["VEHICLE", "PRICING", "OPTIONS", "IMAGES"];
  const payloads = await Promise.all(tabs.map((tab) => getInventoryDetail(id, tab)));

  return payloads.reduce(
    (merged, payload) => ({
      ...merged,
      ...(payload || {}),
      inventory_vehicle: {
        ...(merged.inventory_vehicle || {}),
        ...(payload?.inventory_vehicle || {}),
      },
      inventory_pricing: {
        ...(merged.inventory_pricing || {}),
        ...(payload?.inventory_pricing || {}),
      },
      inventory_marketing:
        payload?.inventory_marketing ?? merged.inventory_marketing ?? null,
      images: payload?.images ?? merged.images ?? [],
      options: payload?.options ?? merged.options ?? {},
      additional_options:
        payload?.additional_options ?? merged.additional_options ?? "",
      seller_notes: payload?.seller_notes ?? merged.seller_notes ?? "",
    }),
    {}
  );
};

export const updateInventory = async (id, data, tenantId) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: tenantId ? { tenantId } : {},
    };
    const response = await restClient.put(`inventory-detail/${id}`, { data: data }, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};


// Inventory Expenses API
export const updateInventoryExpense = async (documentId, data) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.put(`inventory-expenses/${documentId}`, { data }, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const deleteInventoryExpense = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.delete(`inventory-expenses/${id}`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const addInventoryExpense = async (documentId, data) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.post(`inventory-expenses/${documentId}`, { data }, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
export const getInventorySettings = async () => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.get(`inventory-settings`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const updateInventorySettings = async (id, data) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.put(`inventory-settings/${id}`, { data: data }, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const printInventory = async (inventoryId, documents) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      responseType: 'blob',
    };
    const response = await restClient.post(
      `inventories/ecabinet-viewer`,
      { inventory_id: inventoryId, documents },
      config
    );
    return response;
  } catch (err) {
    console.log(err);
    throw err;
  }
};